

import { useStateManager } from "@bcm-dev/bcms-vite";
import CustomSelect, { CustomSelectItem } from "components/custom-ui/CustomSelect";
import DateSelect from 'components/custom-ui/DateSelect';
import { FormContainer, FormRowView } from 'components/shared';
import InfoAlertView from "components/shared/views/InfoAlertView";
import { PrimaryButton, SecondaryButton, UIAmountInput, UITextInput } from 'components/ui';
import React from 'react';
import { SVGAsset } from "res";
import TASPositivePayViewChecksNoResultsContent from "../TASPositivePayViewChecksNoResultsContent";

/**
 * @function TASPositivePayViewChecksDesktopFormView
 * @return {React.Component}
 * @exported true
 * @description The TAS Positive Pay View Checks desktop content view.
 */
export default function TASPositivePayViewChecksDesktopFormView() {
    const { data, ui, onAddChecks, onChange, onClear, onSearch } = useStateManager();
    const search = data.search;
    
    return (
        <div className="show-on-desktop">
            { !ui.didSearch.isActive && 
            <div className="flex-container flex-horizontal past-review-cutoff-time-container">
                <div className="set-width curfew-alert">
                    <InfoAlertView text="Please use search to find checks." icon={ <SVGAsset id="InfoIcon" /> } />
                </div>
            </div>
            }
            <div>SEARCH</div>
            <FormContainer>
                <div className="flex-container flex-horizontal">
                    <div className="set-width item">
                        <FormRowView text="Account">
                            <CustomSelect active={ ui.accountSelect.isActive } onChange={ onChange("accountID") }>
                                <CustomSelectItem value="prompt"></CustomSelectItem>
                            </CustomSelect>
                        </FormRowView>
                    </div>
                    <div className="set-width item">
                        <FormRowView text="Payee">
                            <UITextInput value={ search.payee } onChange={ onChange("payee") } />
                        </FormRowView>
                    </div>
                    <div className="set-width item">
                        <FormRowView text="Status">
                            <CustomSelect value={ search.status } active={ ui.accountSelect.isActive } onChange={ onChange("status") }>
                                <CustomSelectItem value="all">All</CustomSelectItem>
                                <CustomSelectItem value="reconciled">Reconciled</CustomSelectItem>
                                <CustomSelectItem value="notReconciled">Not Reconciled</CustomSelectItem>
                            </CustomSelect>
                        </FormRowView>
                    </div>
                    <div className="set-width item">
                        <FormRowView text="Check Number From">
                            <UITextInput value={ search.checkNumberFrom } onChange={ onChange("checkNumberFrom") } />
                        </FormRowView>
                    </div>
                    <div className="set-width item">
                        <FormRowView text="Check Number To">
                            <UITextInput value={ search.checkNumberTo } onChange={ onChange("checkNumberTo") } />
                        </FormRowView>
                    </div>
                </div>
                <div className="flex-container flex-horizontal">
                    <div className="set-width item">
                        <FormRowView text="Issued Date From">
                            <DateSelect value={ search.issuedDateFrom } enablePast={ true } onChange={ onChange("issuedDateFrom") }  />
                        </FormRowView>
                    </div>
                    <div className="set-width item">
                        <FormRowView text="Issued Date To">
                            <DateSelect value={ search.issuedDateTo } enablePast={ true } onChange={ onChange("issuedDateTo") } />
                        </FormRowView>
                    </div>
                    <div className="set-width item">
                        <FormRowView text="Minimum Amount">
                            <UIAmountInput className="amount-field" value={ search.minimumAmount } onChange={ onChange("minimumAmount") } />
                        </FormRowView>
                    </div>
                    <div className="set-width item">
                        <FormRowView text="Maximum Amount">
                            <UIAmountInput className="amount-field" value={ search.maximumAmount } onChange={ onChange("maximumAmount") } />
                        </FormRowView>
                    </div>
                    <div className="set-width item"></div>
                </div>
                <div className="flex-container flex-horizontal button-container">
                    <SecondaryButton className="set-width" text="Clear" onClick={ onClear } />
                    <PrimaryButton className="set-width" text="Search" data-point="Search_Button" onClick={ onSearch } />
                </div>
            </FormContainer>
            {/* Statically shown until checks are added to the model. */}
            { ui.didSearch.isActive && 
            <TASPositivePayViewChecksNoResultsContent onAddChecks={ onAddChecks } />
            }
        </div>
    )
}